// Footer.jsx
import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <p className="footer-text">© 2025 Weather Application Team-15</p>
    </footer>
  );
}

export default Footer;
